import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-lg pb-5 font-semibold" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "flex my-2 cols-2" }
const _hoisted_4 = { class: "mr-2 max-w-fit" }
const _hoisted_5 = { class: "w-[75%]" }
const _hoisted_6 = { class: "flex w-full" }
const _hoisted_7 = { class: "flex w-full gap-4" }
const _hoisted_8 = { class: "w-[20%] ml-4" }
const _hoisted_9 = { class: "flex mt-4 w-full justify-center" }

import {onMounted, reactive, ref} from "vue";
  import TablesService from "@/services/tables/tables.service";
  import {useRoute} from "vue-router";
  import {useForm} from "vee-validate";
  import { Button } from '@/components/ui/button'
  import {
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
  } from '@/components/ui/form'
  import { Checkbox } from '@/components/ui/checkbox'
  import {Input} from "@/components/ui/input";
  import OrderServiceService from "@/services/order_service/orderService.service";
  import router from "@/router";
  import {ImagePlus} from "lucide-vue-next";
  import {toast} from "@/utils/utils";
  import {i18n} from "@/utils/i18n";
  import Spinner from "@/components/ui_custom/spinner/Spinner.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceOrder',
  setup(__props) {

const route = useRoute();
  let coverage: any = reactive({ elements: [] });
  let isLoading = ref(false);
  async function getCoverage() {
    const res = await TablesService.getCoverageServiceOrderById(route.params.entity as string, route.params.id, route.params.serviceOrderId);
    coverage.elements = res?.data;
  }

  const { handleSubmit, setValues } = useForm()

  function createBody(defects: any) {
    let body: any = {
      bulk: []
    }
    Object.keys(defects).forEach(key => {
      let obj: any = {}
      if (defects[key].id) {
        const ids = defects[key].id.split(';')
        obj.defect = JSON.parse(ids[0])
        obj.defectDimensions = defects[key].dimensions
        obj.defectTotal = defects[key].total
        obj.coverage = {
          id: coverage.elements.id,
          dimensions: coverage.elements.dimensions,
          rci: coverage.elements.rci
        }
        obj.coverageElement = Number(ids[1]);
        obj.serviceOrder = Number(route.params.serviceOrderId);
        body.bulk.push(obj);
      }
    })
    return body;
  }

  const onSubmit = handleSubmit(async (values) => {
    isLoading.value = true;
    const body = createBody(values.defects);
    if (coverage.elements.coverageData?.length > 0) {
      await OrderServiceService.updateCoverageDataByServiceOrder(coverage.elements.coverageData);
    }
    const res = await OrderServiceService.createMultipleCoverageData(body);
    if (res?.status === 201) {
      await getCoverage();
      if (coverage.elements.coverageData?.length > 0) {
        setValues(await initializeForm());
      }
      isLoading.value = false;
      toast.success(i18n.global.t('toast.insert_success'));
    }
    isLoading.value = false;
  })

  function initializeForm() {
    const obj: any = { defects: {} };
    coverage.elements.coverageData.forEach((element: any) => {
      const id = JSON.parse(JSON.stringify(element.defect))
      obj.defects['defect'+element.defect.id] = { id: JSON.stringify(id)+';'+element.coverageElement.id, dimensions: element.defectDimensions, total: element.defectTotal }
    });
    return obj;
  }

  async function openCamera(defectId: number) {
    await onSubmit();
    await router.push({
      name: 'camera',
      params: {id: +defectId, entity: 'defects', serviceOrderId: route.params.serviceOrderId}
    })
  }

  onMounted(async () => {
    await getCoverage();
    if (coverage.elements.coverageData?.length > 0) {
      setValues(await initializeForm());
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Spinner, { "is-loading": _unref(isLoading) }, null, 8, ["is-loading"]),
    _createElementVNode("form", {
      class: "w-full m-[2%]",
      onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)))
    }, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('menu.service_order' )), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coverage).elements.coverageElements, (element, index) => {
        return (_openBlock(), _createBlock(_unref(FormField), {
          key: index,
          name: "defects"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FormItem), { class: "mb-10" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(FormLabel), { class: "text-base font-bold" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(element.code), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("p", null, _toDisplayString(element.description), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.defects, (defect, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "w-full"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(FormLabel), { class: "text-base font-semibold" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(defect.code), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(defect.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_unref(FormField), {
                        type: "checkbox",
                        value: JSON.stringify(defect) + ';' + element.id,
                        "unchecked-value": false,
                        name: 'defects.defect'+ defect.id + '.id'
                      }, {
                        default: _withCtx(({ value, handleChange }) => [
                          _createVNode(_unref(FormItem), { class: "flex flex-row space-x-3 space-y-0 w-[5%] items-center" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(FormControl), null, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Checkbox), {
                                    checked: value,
                                    "onUpdate:checked": handleChange
                                  }, null, 8, ["checked", "onUpdate:checked"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value", "name"]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(FormField), {
                          name: 'defects.defect'+ defect.id +'.dimensions'
                        }, {
                          default: _withCtx(({ componentField }) => [
                            _createVNode(_unref(FormItem), { class: "w-[80%]" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(FormControl), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Input), _mergeProps({ ref_for: true }, componentField, {
                                      placeholder: _ctx.$t('column.defect_dimensions'),
                                      type: "text",
                                      "auto-correct": "off"
                                    }), null, 16, ["placeholder"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["name"]),
                        _createVNode(_unref(FormField), {
                          name: 'defects.defect'+ defect.id +'.total'
                        }, {
                          default: _withCtx(({ componentField }) => [
                            _createVNode(_unref(FormItem), { class: "w-[80%]" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(FormControl), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(Input), _mergeProps({ ref_for: true }, componentField, {
                                      placeholder: _ctx.$t('column.total'),
                                      type: "text",
                                      "auto-correct": "off"
                                    }), null, 16, ["placeholder"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["name"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(Button), {
                          onClick: _withModifiers(($event: any) => (openCamera(+defect.id)), ["prevent"]),
                          disabled: _unref(coverage).elements.coverageData?.length === 0,
                          type: "button",
                          class: "text-center w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ImagePlus), { class: "mr-2 h-5 w-5" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_photo')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ]),
                    _createVNode(_unref(FormMessage))
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(Button), {
          type: "submit",
          class: "w-[90%]"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('table.save')), 1)
          ]),
          _: 1
        })
      ])
    ], 32)
  ], 64))
}
}

})